import { TableContainer, TableBody, TableCell } from "@mui/material";
import { StyledTable } from "../../../../components/FighterCard/StyledTable";
import { TeamInfo } from "../../../../model/Dto/TeamView";
import { StyledTableRow } from "../StyledTableRow";

interface TeamInfoTableProps {
  info: TeamInfo | undefined;
}

export function TeamInfoTable({ info }: TeamInfoTableProps) {
  return (
    <TableContainer>
      <StyledTable size="small">
        <TableBody>
          <StyledTableRow>
            <TableCell>Название</TableCell>
            <TableCell>{info?.name}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCell>Фракция</TableCell>
            <TableCell>{info?.faction.name}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCell>Кредиты</TableCell>
            <TableCell>{info?.cash}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCell>Рейтинг</TableCell>
            <TableCell>{info?.rating}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCell>Репутация</TableCell>
            <TableCell>{info?.reputation}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCell>Количество игр</TableCell>
            <TableCell>{info?.gamesPlayed}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCell>Статус</TableCell>
            <TableCell>
              {info?.isOutlaw === true ? "Вне закона" : "Законники"}
            </TableCell>
          </StyledTableRow>
        </TableBody>
      </StyledTable>
    </TableContainer>
  );
}
